import { useEffect } from "react";

var useMatomoScript = function useMatomoScript(source, websiteId) {
  useEffect(function () {
    var script = document.createElement("script");
    script.text = "var _paq = (window._paq = window._paq || []);\n    /* tracker methods like \"setCustomDimension\" should be called before \"trackPageView\" */\n    _paq.push([\"trackPageView\"]);\n    _paq.push([\"enableLinkTracking\"]);\n    (function () {\n      var u = \"".concat(source, "\";\n      _paq.push([\"setTrackerUrl\", u + \"matomo.php\"]);\n      _paq.push([\"setSiteId\", \"").concat(websiteId, "\"]);\n      var d = document,\n        g = d.createElement(\"script\"),\n        s = d.getElementsByTagName(\"script\")[0];\n      g.async = true;\n      g.src = u + \"matomo.js\";\n      s.parentNode.insertBefore(g, s);\n    })();");
    document.head.appendChild(script);
    return function () {
      document.head.removeChild(script);
    };
  }, [source, websiteId]);
};

export default useMatomoScript;